import { LISTEN_ON_SAVE_BUSINESS_PROFILE } from "../actions/BusinessProfile";

const initialState = {
  businessProfileSavedSuccess: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LISTEN_ON_SAVE_BUSINESS_PROFILE:
      return {
        ...state,
        businessProfileSavedSuccess: action.payload,
      };
    default:
      return state;
  }
};
export default reducer;
